'use strict'

import React from 'react'

function ProductItemPrice (props) {

  return (
    <div className="price-block">
      <div className="price-box">
        {
          props.hasOwnProperty('OLD_PRICE') ?
            <div className="price-old">
              <span>{props.OLD_PRICE_FORMATED}</span>
            </div> :
            <></>
        }
        <div className="price">
          <span data-container="product-price">{props.PRICE_FORMATED}</span>
        </div>
      </div>
    </div>
  )
}

export default ProductItemPrice